export enum AddressInputErrorTypes {
  MISSING_ZIP = "MISSING_ZIP",
  IS_DELIVERR_WAREHOUSE = "IS_DELIVERR_WAREHOUSE",
  PORT_NOT_SUPPORTED = "PORT_NOT_SUPPORTED",
}
